<!-- Header -->
<h3 mat-dialog-title
	translate>
	Templates from Classic
</h3>

<!-- Body -->
<mat-dialog-content>

	<!-- Paginator -->
	<mat-paginator [pageSize]="50"
		[length]="legacyQueries.length"
		[pageSizeOptions]="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 500, 1000]"
		[showFirstLastButtons]="true"></mat-paginator>

	<!-- Header Row -->
	<mat-table>

		<!-- Name Column -->
		<ng-container matColumnDef="Name">
			<mat-header-cell *matHeaderCellDef translate>
				Name
			</mat-header-cell>
		</ng-container>

		<!-- Name Column -->
		<ng-container matColumnDef="Description">
			<mat-header-cell *matHeaderCellDef translate>
				Description
			</mat-header-cell>
		</ng-container>

		<!-- Name Column -->
		<ng-container matColumnDef="Scope">
			<mat-header-cell *matHeaderCellDef translate>
				Scope
			</mat-header-cell>
		</ng-container>

		<!-- Name Column -->
		<ng-container matColumnDef="Owner">
			<mat-header-cell *matHeaderCellDef translate>
				Owner
			</mat-header-cell>
		</ng-container>

		<!-- Row Definition -->
		<mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
	</mat-table>

	<!-- Table Rows -->
	<div style="overflow: auto">
		<mat-table [dataSource]="tableData">

			<!-- Name Column -->
			<ng-container matColumnDef="Name">
				<mat-cell *matCellDef="let query">
					{{query.QueryName}}
				</mat-cell>
			</ng-container>

			<!-- Name Column -->
			<ng-container matColumnDef="Description">
				<mat-cell *matCellDef="let query">
					{{query.Description}}
				</mat-cell>
			</ng-container>

			<!-- Name Column -->
			<ng-container matColumnDef="Scope">
				<mat-cell *matCellDef="let query">
					{{query.Scope}}
				</mat-cell>
			</ng-container>

			<!-- Name Column -->
			<ng-container matColumnDef="Owner">
				<mat-cell *matCellDef="let query">
					{{query.OwnerName}}
				</mat-cell>
			</ng-container>

			<!-- Row Definition -->
			<mat-row *matRowDef="let row; columns: columns; let i = index;"
				id="legacyQueryRow{{i}}"
				matRipple
				tabindex="0"
				style="overflow: hidden"
				(click)="queryClick(row)">
			</mat-row>
		</mat-table>
	</div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button image="Cancel.png"
			label="Close"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>